/* eslint-disable */ import { memoEval, priceComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const roomItemComponents = [
    attachComponent.withComponent(priceComponent, 'default', true).withAlias('RoomItem').attach(memoEval((self)=>[
            self.$price
        ], ($price)=>({
            price: $price
        })))
];

//# sourceMappingURL=room-item.js.map